import {TableRowProps} from 'react-markdown/lib/ast-to-react';

import {tableRow} from '../Markdown.css';

export const TableRow = ({children, isHeader}: React.PropsWithChildren<TableRowProps>) => {
  return <tr className={tableRow({isHeader})}>{children}</tr>;
};
